import {draftKey} from "../chapters/Chapter";
import type {RootState} from "../store";

function selectChapterEditorOpened(state: RootState): boolean {
	return draftKey in state.chapters.byKey;
}

export default selectChapterEditorOpened;
